import React, { useState } from 'react';
import styled from 'styled-components';

const lastPasswordIgnore = (autoComplete?: string, name?: string) =>
  (!autoComplete && !name) || autoComplete === 'none' || autoComplete === 'off'
    ? true
    : undefined;

const Input = styled.input<{ $isRightAlign: boolean; $displayErrors: boolean }>`
  width: 100%;
  min-width: 150px;
  text-align: ${({ $isRightAlign }) => ($isRightAlign ? 'right' : 'initial')};

  padding: 0 10px;
  border-radius: 2px;
  border: none;
  color: white;
  height: 40px;

  outline: none;

  transition: 0.5s background-color ease;

  background: var(--mainDark);
  border: 1px solid transparent;

  &:active,
  &:focus {
    /* background: rgba(0, 0, 0, 0.04); */
    /* TODO: proper color */
    /* border: 1px solid #ffffff55; */
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:required:invalid {
    ${({ $displayErrors }) =>
      $displayErrors ? 'border: 1px solid #922248 !important;' : ''}
  }
`;

type Props = {
  value?: string | number;
  title?: string;
  onChange: (value: string) => void;
  type?: 'text' | 'password' | 'email' | 'date' | 'number';
  maxLength?: number;
  min?: string;
  max?: string; // Used for limiting date picker input
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
  pattern?: string;
  // decimalNumberPattern?: boolean;
  rightAlign?: boolean;
  /**
   * @see https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill
   */
  name?: string;
  /**
   * @see https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill-field
   */
  autoComplete?: string;
  /**
   * Automatically focus the field on initial page load
   */
  autoFocus?: boolean;
  step?: string;
  id?: string;
  className?: string;
};

const TextInput = ({
  id,
  value,
  name,
  /** Title can be used to explain HTML5 errors */
  title,
  onChange,
  maxLength,
  disabled = false,
  required = false,
  placeholder = undefined,
  pattern,
  type = 'text',
  max,
  min,
  step,
  rightAlign = false,
  autoComplete,
  autoFocus = false,
  className,
}: Props) => {
  const [blured, setBlured] = useState<boolean | null>(null);
  return (
    <Input
      className={`unstyled ${className}`}
      id={id}
      name={name}
      data-lpignore={lastPasswordIgnore(autoComplete, name)}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      data-blured={blured}
      $displayErrors={blured === true}
      type={type}
      placeholder={placeholder}
      disabled={disabled}
      title={title}
      maxLength={maxLength}
      max={max}
      min={min}
      step={step}
      required={required}
      pattern={
        /* HTML5 Validation pattern */
        pattern
        // decimalNumberPattern === true ? '[0-9]+([.][0-9]+)' : pattern
      }
      onChange={event => onChange(event.target.value)}
      onFocus={() => setBlured(false)}
      $isRightAlign={rightAlign}
      onBlur={() => {
        // Make sure there are not trailing spaces when going out of input
        const originalValue = `${value}`;
        const trimmedValue = originalValue.trim();
        if (originalValue !== trimmedValue) {
          onChange(trimmedValue);
        }

        setBlured(true);
      }}
      value={value}
    />
  );
};

export default TextInput;
